import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationService, Message, MessageService} from 'primeng/api';
import {CaseService} from '../../services/case.service';
import {UtilitiesService} from '../../services/utilities.service';
import {CookieService} from 'ngx-cookie-service';

import {ApplicationCaseDto} from './dto/application-case.dto';
import {ApplicationPropertyDto} from './dto/application-property.dto';
import {ApplicationCaseCommentDto} from "./dto/application-comments.dto";
// import { InactivityService } from 'src/app/services/inactivity.service';

/*
import { ApplicationAssessorDto } from './dto/application-assessor.dto';
import { ApplicationValueDto } from './dto/application-value.dto';
import { ApplicationFactsDto } from './dto/application-facts.dto';
import { IApplicant } from 'src/app/shared/classes/applicant';
import { IAgency } from 'src/app/shared/classes/agency';
*/

@Component({
  selector: 'app-case',
  templateUrl: './case.component.html'
})
export class CaseComponent implements OnInit {

  tdy: Date;
  caseId: string;
  numAccordionTabs = 10;
  accordionOpenIndex = [];
  applicationCase: any; // ApplicationCaseDto;
  applicationProperty: any; // ApplicationPropertyDto;
  applicationApplicant: any; // IApplicant;
  applicationAgent: any; // IAgency;
  applicationAssessor: any; // ApplicationAssessorDto;
  applicationValues: any;
  applicationFacts: any;
  applicationDocs: any;
  applicationComments: any;
  myApplication: any; // composite object containing ALL fields, child-objects associated w/ case
  myHistComment: any;
  myHistCommentText: string = "";
  commentMode = "";
  isNewCase = false;
  isLateCase = false;
  saveAsLate = '';
  isInsufficientCase = false;
  saveAsInsufficient = '';
  isPaid: boolean ;
  isClosed = false;

  daysToExpiration: number;
  hasWaiver: string = ''; // if waiver accepted, display message in initial section, next to "Days to Expiration"...

  complexCaseDaysRemain: string = '';   // string representing # of days remaining to process complex case
  eFileId: number;  // E-File Application ID
  formattedAPN = ''; // formatted APN to insert dashes, where applicable

  applicantType: string;
  accordionDataCounter = 0;
  accordionTarget = 3;  // # of accordions/tabs needed to allow editing; might be different depending on user type (appraiser vs admin)
  isAssessor = false;          // determine if user has Assessor-related user role
  userName = '';
  userRole = '';   // i.e. Administrator, Assessor, Assessor-Manager, etc...
  allowSave = true;

  displayState: any = {
    workingDiv: false,
    caseDiv: false,
    addCaseCommentDiv: false,
    saveDisabled: false,
};

  constructor(private caseService: CaseService, private utilService: UtilitiesService,
              private router: Router, private route: ActivatedRoute, private messageService: MessageService,
              private confirmationService: ConfirmationService, private cookieService: CookieService)
  {
    this.caseId = route.snapshot.paramMap.get('caseid');
    this.applicationCase = new ApplicationCaseDto().create();
    this.applicationProperty = new ApplicationPropertyDto().create();
    this.myHistComment = new ApplicationCaseCommentDto().create();
  }

  createCase() {
    this.initializeCaseObj();
    this.isNewCase = true;    // will disable some of the accordion tabs until the case has been saved, i.e. documents, e-filed docs, minutes, etc
    this.displayState.workingDiv = false;
    this.displayState.caseDiv = true;
  }
  ngOnInit() {
    let uRole = this.cookieService.get('userRole'); // get the role from login cookie
    if (uRole) {
      this.userRole = uRole;
    } else {
      uRole = this.userRole;
    }
    this.userName = this.cookieService.get('userName');
    this.utilService.doAudit('caseId:' + this.caseId + '; role: ' + uRole + '; name: ' + this.userName);
    if (this.caseId == '0' || this.caseId === null) {
      // this is a NEW case; handle it!
      this.createCase();
      return;
    }
    if (uRole.includes('Assessor')) {
      this.isAssessor = true;
      this.allowSave = false;
    } else if (uRole.includes('Read')) {
      this.allowSave = false;
    } else if (this.utilService.isDeveloper()) {
      this.isAssessor = true;   // allow developers access to the Assessor module!
    }
    // OK to get Case (and other) info for specified caseId...
    this.initializeCaseObj();
    // QUESTION:  should we have ONE API call to get a composite object consisting of all case/application-related data??
    //            this would help w/ performance AND simplify code (i.e. less need to deal w/ async calls returning data in spurts...)
    this.displayState.workingDiv = true;
    this.utilService.doAudit('getting case...');
    this.caseService.getCase(this.caseId).subscribe(data => {
      this.utilService.doAudit(data, 'get case response');
      this.eFileId = data.efileId;
      this.accordionDataCounter = ++this.accordionDataCounter;
      //
      let xDate;
      this.applicationCase = data;
      // *** NOTE:  convert any date fields to proper format...
      xDate = data.dateReceived;
      if (xDate != null) {
          xDate = xDate.slice(0, 10) + 'T10:00:00';
          this.applicationCase.dateReceived = new Date(xDate);
      }
      xDate = data.datePostmarked;
      if (xDate != null) {
          xDate = xDate.slice(0, 10) + 'T10:00:00';
          this.applicationCase.datePostmarked = new Date(xDate);
      }

      xDate = data.waiverExpDate;
      if (xDate != null) {
          xDate = xDate.slice(0, 10) + 'T10:00:00';
          this.applicationCase.waiverExpDate = new Date(xDate);
      }

      xDate = data.dateConfirmationReceived;
      if (xDate != null) {
          xDate = xDate.slice(0, 10) + 'T10:00:00';
          this.applicationCase.dateConfirmationReceived = new Date(xDate);
      }
      // applicant323Date and assessor323Date fields added 6/2024 - rod
      xDate = data.applicant323Date;
      if (xDate != null) {
        xDate = xDate.slice(0, 10) + 'T10:00:00';
        this.applicationCase.applicant323Date = new Date(xDate);
      }
      //
      xDate = data.assessor323Date;
      if (xDate != null) {
        xDate = xDate.slice(0, 10) + 'T10:00:00';
        this.applicationCase.assessor323Date = new Date(xDate);
      }
      this.daysToExpiration = null;
      if (data.waiverReceived) {
        // at some point, take into account waiverExpDate
        this.isClosed = false;
        this.hasWaiver = ' - Waiver';
      }
      // *** other than having a dateClosed, are there any other conditions that classify the case as "Closed"?
      if (data.dateClosed) {
        this.isClosed = true;
      } else {
        const daysToExpire =  this.getDaysToExpiration();
        if (daysToExpire > 0) {
          this.daysToExpiration = daysToExpire;
        } else {
          // *** WARNING!! IF WE HAVE A NEGATIVE DaysToExpiration value, AND THE CASE IS NOT CLOSED,  IT MEANS THE APPEALS EXPIRED!!
          //  for now, show it as "Closed"
          // this.isClosed = true;
        }
      }
      this.utilService.doAudit(this.daysToExpiration, 'days to exp');

      this.isPaid = !!data.receiptNum;  // set to true if there's a receiptNum, otherwise set to false

      this.applicantType = data.applicantType;  // displayed in Applicant tab
      this.utilService.doAudit('efileId: ' + data.efileId);
      this.myApplication.case = this.applicationCase;

      this.caseService.getCaseProperty(this.caseId).subscribe(data2 => {
        this.applicationProperty = data2; // needed here to display APN
        this.myApplication.property = data2;
        this.utilService.doAudit(data2, 'get property response');
        this.formattedAPN = this.utilService.formatString("APN", data2.apn);
        this.accordionDataCounter = ++this.accordionDataCounter;
        this.checkAllDataLoaded();
      });
      this.getHistComments();
      // this data contains reference to complex case... - rod
      this.caseService.getCaseAssessor(this.caseId).subscribe(data3 => {
        this.applicationAssessor = data3; // needed here to display Assessor Name and Complex Case values
        if (data3.complexCase && !this.isClosed) {
          // IFF it's a complex case AND it is not closed!
          // calculate # of days remaining:  120 - (tdy - date postmarked/received)
          const numDays = this.calcDaysRemaining(120);
          this.complexCaseDaysRemain = " - Days Remaining: " + numDays;
        } else {
          this.complexCaseDaysRemain = "";
        }
        this.utilService.doAudit(data3, 'get assessor response');
        this.accordionDataCounter = ++this.accordionDataCounter;
        this.checkAllDataLoaded();
      });
      /*
      this.displayState.workingDiv = false;
      this.displayState.caseDiv = true;
       */
    });
  }
  updateStatus() {
    // event triggered when Case Status changed
    this.caseService.getCase(this.caseId).subscribe(data => {
      this.utilService.doAudit(data, 'status updated - get case response');
      if (data.dateClosed) {
        this.isClosed = true;
        this.daysToExpiration = null;
      } else {
        this.isClosed = false;
        const daysToExpire = this.getDaysToExpiration();
        if (daysToExpire > 0) {
          this.daysToExpiration = daysToExpire;
        } else {
          // *** WARNING!! IF WE HAVE A NEGATIVE DaysToExpiration value, AND THE CASE IS NOT CLOSED
          //     IT MEANS THE APPEALS EXPIRED!!
        }
      }
    });
  }
  // determine if ALL case data has been retrieved; used to signal ok to proceed, hide the "Processing..." div...
  checkAllDataLoaded(): boolean {
    if (this.accordionDataCounter >= this.accordionTarget) {
      this.displayState.workingDiv = false;
      this.displayState.caseDiv = true;
      return true;
    } else { return false;}
  }
  openAllSections() {
    this.accordionOpenIndex = [];
    for (let i = 0; i < this.numAccordionTabs; i++ ) {
      this.accordionOpenIndex.push(i);
    }
  }

  closeAllSections() {
    this.accordionOpenIndex = [];
  }

  getHistComments() {
    this.caseService.getHistCaseComments(this.caseId).subscribe(dataC => {
      this.utilService.doAudit(dataC, 'returned from getHistCaseComments:');
      if (dataC) {
        this.applicationComments = dataC;
      }
    });
  }

  newHistComment() {
    this.myHistCommentText = "";
    this.commentMode = "Add";
    this.myHistComment = {
      applicationId: this.caseId,
      userId: this.userName,
      commentText: "",
      id: 0
    }
    this.displayState.addCaseCommentDiv = true;
  }

  cancelHistComment() {
    this.displayState.addCaseCommentDiv = false;
  }

  saveHistComment() {
    // save the comment real-time??
    if (this.myHistCommentText.length < 1) {
      this.showInfo({ key: 'info', severity: 'info', detail: 'Nothing to save!', summary: 'Info' });
      return;
    }
    this.myHistComment.commentText = this.myHistCommentText;
    const cmtId = this.myHistComment.id;
    if (cmtId == 0) {
      this.caseService.addHistCaseComment(this.caseId, this.myHistComment).subscribe(data => {
        this.utilService.doAudit(data, 'returned from addHistCaseComment:');
        if (data) {
          this.showInfo({ key: 'info', severity: 'info', detail: 'Case comment was saved', summary: 'Info' });
          this.getHistComments(); // refresh list of case comments
        } else {
          this.showInfo({ key: 'info', severity: 'info', detail: 'Problem saving comment!', summary: 'Info' });
        }
        // regardless of outcome, clear out the comment and disable the div
        this.myHistCommentText = "";
        this.displayState.addCaseCommentDiv = false;
      });
    } else {
      this.caseService.updateHistCaseComment(cmtId, this.myHistComment).subscribe(data => {
        this.utilService.doAudit(data, 'returned from updateHistCaseComment:');
        if (data) {
          this.showInfo({ key: 'info', severity: 'info', detail: 'Case comment was saved', summary: 'Info' });
          this.getHistComments(); // refresh list of case comments
        } else {
          this.showInfo({ key: 'info', severity: 'info', detail: 'Problem saving comment!', summary: 'Info' });
        }
        // regardless of outcome, clear out the comment and disable the div
        this.myHistCommentText = "";
        this.displayState.addCaseCommentDiv = false;
      });

    }
  }
  editHistComment(cmt: any)
  {
    this.utilService.doAudit(cmt, 'Editing comment:');
    this.myHistCommentText = cmt.commentText;
    this.commentMode = "Edit";
    this.myHistComment = {
      applicationId: this.caseId,
      userId: this.userName,
      commentText: cmt.commentText,
      id: cmt.id
    }
    this.displayState.addCaseCommentDiv = true;
    // let x = cmt.id;
  }
  allowCmtEdit(cmt: any)
  {
    if (this.userName == cmt.userId) {
        return true;
    } else if (this.userRole.includes('Admin')) {
      // return true;
    } else { return false; }
  }

  receiptChange() {
    // if there is a Receipt#, the Paid value is set to True, otherwise it is False
    this.isPaid = !!this.applicationCase.receiptNum;
  }

  getDaysToExpiration(): number {
    let myDate: Date;
    const totNumDays = this.calcDaysToExpiration(); // # of days allowed until Application expires (default = 2 years)
    let myStartDt = new Date();
    // determine which date to use as the starting point
    // NOTE: if Application was E-Filed, we'll use the Received Date ??
    if (this.applicationCase.waiverExpDate) {
      myDate = myStartDt;
      myStartDt = this.applicationCase.waiverExpDate;
    } else if (this.applicationCase.datePostmarked) {
      myDate = this.applicationCase.datePostmarked;
    } else if (this.applicationCase.dateReceived) {
      myDate = this.applicationCase.dateReceived;
    }
    // const diffTime = Math.floor(+myToday - +myDate);
    // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    const diffDays = Math.ceil((+myStartDt - +myDate) / (1000 * 60 * 60 * 24));
    return 730 - diffDays;
    // return 101; // DURING TESTING!! -- return this value so as not to forget we need to finish implementing the logic in this method
  }

  // calculate # of days between date when application was submitted (E-Filed) or Postmarked and the same date two years in future
  // NOTE: we need to account for Leap Years, et al (factors?)
  calcDaysToExpiration(): number {
    let myDate: Date;
    if (this.applicationCase.datePostmarked) {
      myDate = this.applicationCase.datePostmarked;
    } else if (this.applicationCase.dateReceived) {
      myDate = this.applicationCase.dateReceived;
    }
    let myDay = myDate.getDate(), myMonth = myDate.getMonth() + 1, myYear = myDate.getFullYear();
    if (myDay == 29) {  // if this is Feb 29th, should the future date be Feb 28th or Mar 01?
      myDay = 28;
    }
    // get same date, 2 years in future
    const nDate = (myYear + 2) + '-' + myMonth + '-' + myDay;
    const futureDate = new Date(nDate);
    return this.utilService.convertDateToDays(futureDate) - this.utilService.convertDateToDays(myDate);
    // return 730;  // *** FOR TESTING ONLY!!
  }
  // FOR COMPLEX CASES:
  //  calculate # of days remaining from when application was submitted/postmarked (+ 120 days) AND today
  calcDaysRemaining(daysToAdd: number): number
  {
    let myDate: Date;
    if (this.applicationCase.datePostmarked) {
      myDate = this.applicationCase.datePostmarked;
    } else if (this.applicationCase.dateReceived) {
      myDate = this.applicationCase.dateReceived;
    }
    let futureDate = new Date(myDate);
    futureDate.setDate(futureDate.getDate() + daysToAdd);
    const tdy = new Date();
    return this.utilService.convertDateToDays(futureDate) - this.utilService.convertDateToDays(tdy);
  }

  // handle data changes in child components here...
  updateApplicant(myApplicant: any) {
    // this.utilService.doAudit(myApplicant, 'data change event received from child component: Applicant');
    this.applicationApplicant = myApplicant;
  }

  updateAgent(myAgent: any) {
    // this.utilService.doAudit(myAgent, 'data change event received from child component: Agent');
    this.applicationAgent = myAgent;
  }

  updateProperty(myProperty: any) {
    // this.utilService.doAudit(myProperty, 'data change event received from child component: Property');
    this.applicationProperty = myProperty;
    this.formattedAPN = this.utilService.formatString("APN", this.applicationProperty.apn);
  }

  updateValues(myValues: any) {
    // this.utilService.doAudit(myValues, 'data change event received from child component: Values');
    this.applicationValues = myValues;
  }

  updateFacts(myFacts: any) {
    // this.utilService.doAudit(myFacts, 'data change event received from child component: Facts');
    this.applicationFacts = myFacts;
  }

  updateDocs(myDocs: any) {
    // this.utilService.doAudit(myDocs, 'data change event received from child component: Documents');
    this.applicationDocs = myDocs;
  }

  updateAssessor(myValues: any) {
    // Note: we're only accepting data from the Assessor component to update the Assessor values data in the Values tab (not necessary?)
    //  - we will NOT be saving the Assessor data here coz Assessors will not have access to the Case's Save button
    this.utilService.doAudit(myValues, 'data change event received from child component: AssessorValues');
    this.applicationValues.valueAssessor = myValues.valueAssessor;
    this.applicationAssessor = myValues.assessor;
    this.applicationProperty.useCode = myValues.useCode;
    if (myValues.readyToExit) {
      // alert('ready to bounce...');
    }
  }

  // Mapping and Saving functions go here...

  // initialize composite Case object
  initializeCaseObj() {
    this.myApplication = {
      case: {},
      applicant: {},
      agency: {},
      property: {},
      caseValue: {
          assessType: '',
          totalValue: null,
          valueDifference: null,
          applicantGroup: {},
          assessorGroup: {},
          opinionGroup: {},
          finalGroup: {},
          isHighValue: null,
      },
      caseFacts: [],
      caseStatus: '',
      efileId: '',
    };
  }

  // exit case without saving any data!
  exitCase() {
    // this.showInfo({key:'info', severity: 'success', summary: 'System Message', detail: 'Exiting Case module' });
    this.router.navigate(['/caselookup/1']);
  }

  // maintain an audit trail...
  updateAuditTrail(msg: string) {
    // for now, add an entry at the end of Case Comments reflecting who saved the case and when...
    const tdy = this.utilService.formatDate(null, '/', false, true);  // this should return the current date/time...
    let cmt = this.applicationCase.comment;
    cmt = (cmt ? cmt + '\n' : '') + msg + ', on: ' + tdy;
    this.utilService.doAudit(cmt, 'adding audit trail comment:');
    this.applicationCase.comment = cmt;
    // consider making an entry in an AuditTrail table...
  }

  saveCase() {
    // save data here...
    // this.accordionDataCounter;
    const myApplication = this.myApplication;

    // calculateTotalValue();
    this.applicationProperty.apn = this.utilService.stripDashes(this.applicationProperty.apn);

    myApplication.case = this.applicationCase;
    //
    myApplication.applicant = this.applicationApplicant;
    myApplication.case.applicantType = myApplication.applicant.type; // coz this field is stored w/ Case-related info...
    myApplication.agency = this.applicationAgent ? this.applicationAgent : null;
    //
    myApplication.caseValue = this.mapValues();
    myApplication.property = this.applicationProperty;
    myApplication.property.rollYear = myApplication.caseValue.rollYear; // coz roll year value collected in the Values component??
    if (this.applicationFacts) {
      myApplication.caseFacts = this.applicationFacts.factsList;
      // update Case coz Claim Refund and Request Finding are collected in the FACTS component; will need to convert String values to Boolean
      let claimRefund = this.applicationFacts.claimRefund;
      if (claimRefund == 'true') { claimRefund = 'Yes'}
      myApplication.case.claimRefund = claimRefund; // === 'Yes' ? true : false;
      myApplication.case.requestFinding = this.applicationFacts.requestFinding === 'Yes' ? true : false;
    }
    myApplication.efileId = this.eFileId ? this.eFileId.toString() : null;

    this.utilService.doAudit(myApplication, 'saving case; myApplication:');
    // added 12/11/14
    // save last applicant, agency or both (depending on what user entered)
    this.saveLastApplicant();
    this.saveLastAgency();

    // let xAppID, theCaseYear = 0, mgmtCaseNumber;
    let theCaseYear = 0;
    // myApplication.caseStatus = 'Ready for Hearing'; // deprecated!  seems to generate a NEW status when saving an existing case - rod 5/11/2022
    theCaseYear = new Date().getFullYear();
    this.utilService.doAudit(myApplication, 'ready to save application for year: ' + theCaseYear + '; myApplication data:');

    if (this.isNewCase) {
      if (this.isLateCase === true && this.saveAsLate === 'Save as LATE') {
        myApplication.caseStatus = 'Late Application Received';
      }
      else if (this.isInsufficientCase === true && this.saveAsInsufficient === 'Save as Insufficient') {
        myApplication.caseStatus = 'Insufficient Application Received';
      }
      else if (myApplication.caseValue.isHighValue) {
        myApplication.caseStatus = 'Ready for Res Status Conference';
      }
      else {
        myApplication.caseStatus = 'Ready for Hearing';
      }
      this.updateAuditTrail('Case created by: ' + this.userName);
      this.caseService.createCase(myApplication, theCaseYear).subscribe(data => {
        this.utilService.doAudit('returned from saveCase service: ' + data);
        if (data) {
          const newAppId = data;  // this should be the new ApplicationId...
          this.caseService.getNewCaseNumber(newAppId).subscribe(dataC => {
            if (dataC.caseNum) {
              const caseNum = dataC.caseNum;
              const xMsg = 'Case number ' + caseNum + ' saved.';
              alert(xMsg);
              // update just the comments on the case and file them...
              // this.caseService.updateCaseComments(newAppId, 'Assigned Case#: ' + caseNum);
            } else {
                alert('Unable to generate new Case #');
            }

          });
        } else {
          alert('Failed to save Case. If the problem persists, please notify support');
        }
        // navigate to Case Lookup page
        this.exitCase();
      });
    } else {
      // update an existing case/application
      this.updateAuditTrail('** Case updated by: ' + this.userName);
      this.utilService.doAudit(myApplication, 'updating case; myApplication:');
      this.displayState.saveDisabled = true;
      this.displayState.workingDiv = true;
      this.caseService.updateCase(myApplication, this.applicationCase.id.toString()).subscribe(data => {
        this.utilService.doAudit(data, 'RESPONSE from updateCase:');
        if (data) {
          this.showInfo({ key: 'info', severity: 'info', detail: 'Case data was Filed', summary: 'Info' });
          // navigate to Case Lookup page??
          // this.exitCase();
        } else {
          this.showInfo({ key: 'info', severity: 'info', detail: 'Problem saving case!', summary: 'Info' });
        }
        this.displayState.workingDiv = false;
        this.displayState.saveDisabled = false;
        /*  NOTE: Assessor data will NOT be saved here (parent); will be done from the (child) Assessor tab... */
      });
    }
  }

  // return composite object containing all Values + additional fields
  // get values from composite object emitted by the CaseValueComponent (upon data changed)
  mapValues() {

    const rollValuePerApplicant = this.applicationValues.valueApplicant;
    const opinionValue = this.applicationValues.valueOpinion;
    const assessorValue = this.applicationValues.valueAssessor;
    const finalValue = this.applicationValues.valueFinal;
    const caseValue = this.applicationValues.caseInfo;
    const rollYear = this.applicationValues.rollYear;

    let isHighValue = false;
    if (rollValuePerApplicant.totalValue > 30000000) { isHighValue = true; }

    // get Total value + Difference (calculated in case-value component, but could be calculated here!)
    const totalValue = this.applicationValues.valueTotal.totalValue;
    const valueDiff = this.applicationValues.valueTotal.valueDifference;

    return {
      isHighValue,
      assessType: caseValue.assessType,
      rollYear,
      totalValue,
      valueDifference: valueDiff,
      applicantGroup: rollValuePerApplicant,
      opinionGroup: opinionValue,
      assessorGroup: assessorValue,
      finalGroup: finalValue,
    };
  }

  saveLastApplicant(): void {
    this.utilService.doAudit(this.myApplication.applicant, 'last applicant to be saved:');
    const obj = JSON.stringify(this.myApplication.applicant);
    localStorage.setItem(this.userName + '-lastApplicant', obj); // username included to make it unique to user
  }
  saveLastAgency(): void {
    this.utilService.doAudit(this.myApplication.agency, 'last agency to be saved:');
    if (this.myApplication.agency) {
      const obj = JSON.stringify(this.myApplication.agency);
      localStorage.setItem(this.userName + '-lastAgency', obj);
    }
  }

  // Toaster/Message-related methods
  showToast(msg: Message) {
    this.messageService.clear('toast');
    this.messageService.add(msg);
  }

  showInfo(myMsg: Message) {
    this.messageService.clear('info');
    this.messageService.add(myMsg);
  }

  clearAll() {
    this.messageService.clear();
  }

}
